import axios from "axios";
import router from "@/router";
import store from "@/store";

const API_URL = process.env.VUE_APP_API_URL;

const HTTP = axios.create({
	baseURL: API_URL,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json'
	}
});

// Add JWT
HTTP.interceptors.request.use(
  config => {
    // Récupérer le JWT du store Vuex
    const jwt = store.state.jwt;
    if (jwt) {
      config.headers['Authorization'] = `Bearer ${jwt}`;
    }
    return config;
  },
  error => {
    // Faire quelque chose avec une erreur de requête
    return Promise.reject(error);
  }
);

// Intercept requests
HTTP.interceptors.response.use(
	response => response, // Renvoie simplement la réponse si tout va bien
	error => {
		if (error.response && error.response.status === 401) {
			store.dispatch("logout");
			router.push("/");
		}
		return Promise.reject(error);
	}
);

export default HTTP;
